let url_config = "https://jiarise.cn/sjmj-api"
// let url_config = "http://localhost:8082/sjmj-api"




export default url_config
